function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import m from "classnames";
import { getPrefixedDataAttributes as d } from "./utils/dom.js";
import { container as f, inverseBackground as l, fullWidth as u, responsiveLayout as c } from "./responsive-layout.css-mistica.js";
import { useIsInverseVariant as p, ThemeVariant as v } from "./theme-variant-context.js";
import { jsx as s } from "./_virtual/jsx-runtime.js";
const N = (param)=>{
    let { children: i , isInverse: t = !1 , backgroundColor: e , className: r , fullWidth: a , dataAttributes: n  } = param;
    const o = p();
    return /* @__PURE__ */ s(v, {
        isInverse: t || o,
        children: /* @__PURE__ */ s("div", _objectSpreadProps(_objectSpread({
            className: m(f, r, {
                [l]: t && !e
            }),
            style: e ? {
                background: e
            } : void 0
        }, d(n)), {
            children: /* @__PURE__ */ s("div", {
                className: a ? u : c,
                children: i
            })
        }))
    });
};
export { N as default };
